/**
 * Release Notes Improvement Web Component
 * 
 * Handles expand/collapse functionality for improvement blocks
 * Follows SOLID principles and performance best practices
 */
class SaReleaseNotesImprovement extends HTMLElement {
  constructor() {
    super();
    
    this._isExpanded = this.dataset.defaultExpanded !== 'false';
    this._heading = null;
    this._content = null;
    
    // Bind methods
    this._handleClick = this._handleClick.bind(this);
  }

  connectedCallback() {
    this._initialize();
    this._attachEventListeners();
  }

  disconnectedCallback() {
    this._removeEventListeners();
    this._cleanup();
  }

  /**
   * Initialize component
   * Cache DOM elements for performance
   */
  _initialize() {
    this._heading = this.querySelector('.release-notes-improvement-heading');
    this._content = this.querySelector('.release-notes-improvement-content');
    
    if (this._isExpanded) this.classList.add('expanded');
  }

  /**
   * Attach event listeners
   */
  _attachEventListeners() {
    if (this._heading) {
      this._heading.addEventListener('click', this._handleClick);
    }
  }

  /**
   * Remove event listeners
   */
  _removeEventListeners() {
    if (this._heading) {
      this._heading.removeEventListener('click', this._handleClick);
    }
  }

  /**
   * Handle click event
   * Toggle expand/collapse state
   */
  _handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    this._toggle();
  }

  /**
   * Toggle expand/collapse
   * Uses CSS variable to control max-height
   */
  _toggle() {
    this._isExpanded = !this._isExpanded;
    
    if (this._isExpanded) {
      this.classList.add('expanded');
      // Set CSS variable to 5000px for expanded state
      this.style.setProperty('--sa-rn-content-max-height', '5000px');
    } else {
      this.classList.remove('expanded');
      // Set CSS variable to 0px for collapsed state
      this.style.setProperty('--sa-rn-content-max-height', '0px');
    }
  }

  /**
   * Cleanup method
   */
  _cleanup() {
    this._heading = null;
    this._content = null;
  }
}

// Register custom element
if (!customElements.get('sa-release-notes-improvement')) {
  customElements.define('sa-release-notes-improvement', SaReleaseNotesImprovement);
}

